module.exports = __webpack_public_path__ + "img/justify_center.d2398fb7.svg";